import BaseClient from '@/app/model/api/response/baseApiClient'

class DistrictEditApi extends BaseClient {
  public doDistrictEdit (id: string, bodyData: {[key:string]: any}) {
    const path:string = '/v1/master/districts/' + id

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'PUT')
  }
}

export default new DistrictEditApi()
